const baseURL = `${process.env.REACT_APP_BASE_URL}/api`

const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

// API to reset password
const deleteAccountApi = async (
    token: string, // reset password token
): Promise<any> => {

    const url = `${baseURL}/user/delete`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
        });
        return await response.status;
    } catch (error) {
        return Promise.reject;
    }

}

export {deleteAccountApi}
